import type { EChartsExtensionInstallRegisters, ExtensionAPI } from 'echarts';
import {
  type FlagInfo,
  prepareFlagInfoList,
  shiftLayoutOnY as shiftFlagLayoutOnY
} from './FlagLayoutHelper';
import {
  getCurvedPointerLayoutListPrepareInput,
  prepareCurvedPointerInfoList,
  shiftLayoutOnY as shiftCurvedPointerLayoutOnY
} from './curvedPointerLayoutHelper';

function adjustFlagPosition(chart: ExtensionAPI) {
  const ecModel = chart.getModel();
  const dvMarkerModel = ecModel
    .getSeriesByType('custom')
    .filter(item => item.option?.dvType === 'dvMarker' && item.option?.dvMarkType === 'flag');

  const gridFlagMarkerMap = new Map<unknown, FlagInfo[]>();

  dvMarkerModel.forEach(markModel => {
    const markView = chart.getViewOfSeriesModel(markModel);
    const gridModel = markModel.coordinateSystem.master;
    const flagInfoList = prepareFlagInfoList(markView);

    if (gridFlagMarkerMap.has(gridModel)) {
      gridFlagMarkerMap.get(gridModel).push(...flagInfoList);
    } else {
      gridFlagMarkerMap.set(gridModel, flagInfoList);
    }
  });

  gridFlagMarkerMap.forEach((flagList, gridModel) => {
    const gridRect = gridModel.getRect();
    shiftFlagLayoutOnY(flagList, gridRect.y, gridRect.y + gridRect.height);
  });
}

function adjustCurvedPointerPosition(chart: ExtensionAPI) {
  const ecModel = chart.getModel();
  const dvMarkerModel = ecModel
    .getSeriesByType('custom')
    .filter(
      item => item.option?.dvType === 'dvMarker' && item.option?.dvMarkType === 'curvedPointer'
    );
  dvMarkerModel.forEach(markModel => {
    const markView = chart.getViewOfSeriesModel(markModel);
    const gridRect = markModel.coordinateSystem.master.getRect();
    const input = getCurvedPointerLayoutListPrepareInput(markView);
    const curvedPointerInfoList = prepareCurvedPointerInfoList(input);
    shiftCurvedPointerLayoutOnY(curvedPointerInfoList, gridRect.y, gridRect.y + gridRect.height);
  });
}

export function dvMarkerExtensionInstall(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:afterupdate', (_, chart) => {
    // todo目前为flag标记特有的位置调整扩展
    adjustFlagPosition(chart);
    adjustCurvedPointerPosition(chart);
  });
}
